import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ShopPage from './pages/ShopPage';
import GamesPage from './pages/GamesPage';
import GamePlayPage from './pages/GamePlayPage';
import MusicPage from './pages/MusicPage';
import { SHOW_GAMES, SHOW_MUSIC, SHOW_SHOP } from './config';
import './styles.css';
import './shop.css';
import './games.css';
import './music.css';

function normalizePath(pathname) {
  const path = (pathname || '/').replace(/\/$/, '') || '/';
  if (path === '/shop' || path === '/shop.html') return '/shop';
  if (path === '/games' || path === '/games.html') return '/games';
  if (path === '/music' || path === '/music.html') return '/music';
  if (path.startsWith('/play/')) return path;
  return '/';
}

function Root() {
  const route = normalizePath(window.location.pathname);
  if (route === '/shop') {
    if (SHOW_SHOP) return <ShopPage />;
    window.history.replaceState(null, '', '/');
  }
  if (route === '/games') {
    if (SHOW_GAMES) return <GamesPage />;
    window.history.replaceState(null, '', '/');
  }
  if (route === '/music') {
    if (SHOW_MUSIC) return <MusicPage />;
    window.history.replaceState(null, '', '/');
  }
  if (route.startsWith('/play/')) {
    if (SHOW_GAMES) {
      const gameId = route.slice('/play/'.length);
      return <GamePlayPage gameId={gameId} />;
    }
    window.history.replaceState(null, '', '/');
  }
  return <App />;
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
